import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./SnapshotMembersList.module.css";

import SnapshotMemberItem from "../SnapshotMemberItem";
import Card from "../../../shared/Card";

/**
 * A view component that displays a scrollable list of members with a header.
 */

export function SnapshotMembersList({ snapshotMembers }) {
  const [_snapshotMembers, setEventMembers] = useState([]);

  useMemo(() => {
    snapshotMembers &&
      snapshotMembers !== null &&
      setEventMembers(snapshotMembers);
  }, [snapshotMembers]);

  return (
    <>
      <Card className={styles.cardContainer}>
        <div className={styles.scrollContainer}>
          <div className={styles.cardContentContainer}>
            {/* Functions as header */}
            <div className={styles.header}>
              <SnapshotMemberItem
                snapshotMemberInfo={{
                  iboNum: "IBO #",
                  name: "IBO Name",
                  pinLevel: "Pin Level",
                  platinum: "Platinum",
                  emerald: "Emerald",
                  diamond: "Diamond",
                }}
              />
            </div>
            <div className={styles.content}>
              {_snapshotMembers.length > 0 ? (
                _snapshotMembers.map((snapshotMemberInfo) => (
                  <div className={styles.snapshotMemberInfo}>
                    <SnapshotMemberItem
                      snapshotMemberInfo={snapshotMemberInfo}
                    />
                  </div>
                ))
              ) : (
                <div className={styles.error}>No data to display.</div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}

SnapshotMembersList.propTypes = {
  // Array of member objects (iboNum- String, name- String, pinLevel- Number, platinum-String, emerald-String, diamond-String)
  snapshotMembers: PropTypes.arrayOf(PropTypes.object),
};

SnapshotMembersList.defaultProps = {
  snapshotMembers: [],
};
